import { gql } from '@apollo/client'

export const GET_EVENT_SIGNED_URL = gql`
  query getEventSignedUrl {
    getEventSignedUrl {
      image
      url
    }
  }
`
